// extracted by mini-css-extract-plugin
export var link = "_t4-0";